<template>
  <div class="animated fadeIn" style="overflow-y:hidden">

    <div class="row">
      <div class="col">
        <span> Rows Per Page:</span>
        <!-- <input v-model="rowsPerPageC" type="number"/> -->
        <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1" :disabled="showLoadingAnimation">
          <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="col" align="center">
        <b-pagination 
          size="sm" 
          :total-rows="totalRowsC" 
          v-model="currentPage" 
          :per-page="rowsPerPageC" 
          hide-ellipsis
          :limit="paginationButtonsLimit" 
          align="center"
          @change="pageChanged"
          >
      </b-pagination>
      </div>
      <div class="col" align="right">
          <span>Total Rows {{totalRowsC}}</span>  
        </div>
    </div>
    
    <br/>
    <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="showLoadingAnimation">Refresh</button>
    <button type="button" class="btn btn-primary" @click="generateClaims()" :disabled="showLoadingAnimation">Generate</button>
    <b-table small bordered hover responsive="true" :items="tableRows" :fields="tableHeaders" @row-clicked="tableRowClicked">
      <template slot="cell(jobNumber)" slot-scope="row">
        <span>{{row.item.jobNumber}}</span>
          <input type="image" 
            src="static/img/download-button.png" 
            alt="download" 
            style="margin-left:5px; margin-right:5px; width: 28px; height: 28px"
            v-if="row.item.status === 'READY_FOR_DOWNLOAD'"
            @click="downloadFileFromGCS(row.item.jobNumber)"
            >
        <a :href="row.item.downloadUrl" v-if="row.item.downloadUrl && row.item.downloadUrl.length > 0">Click here to download</a>
        
      </template>
    </b-table>

    <img src="static/img/Rolling.svg" alt="Loading data..." 
      style="margin-left:auto; margin-right:auto; display: block;"
      v-if="showLoadingAnimation">
    <p style="text-align: center"
      v-if="showLoadingError">
    Loading error:
    </p>
    <p style="text-align: center"
      v-if="showNoResult">
    No Result
    </p>

    <MyModal v-if="showGeneratingModal" v-on:close="closeGeneratingModal()" headerTitle="Generating Reports in Background..." bodyMessage="Reports are being generated in server, it will take a few minutes...You may close this message and refresh the page a few minutes later."/>

    <MyModal v-if="showCannotGenerateModal" v-on:close="closeCannotGenerateModal()" headerTitle="Cannot Generate Report" bodyMessage="Cannot have more than 1 report generation at a time, please wait for that to finish and generate again"/>

    <MyModal v-if="showGeneratingSuccessModal" v-on:close="closeGeneratingSuccessModal()" headerTitle="Success" bodyMessage="Report is still ongoing...Once it is finsihed, the job status will change to READY_TO_DOWNLOAD."/>
    <MyModal v-if="showGeneratingFailedModal" v-on:close="closeGeneratingFailModal()" headerTitle="Failed" :bodyMessage="importFailedMessage"/>

  </div>
</template>

<script>
import { MyModal } from '../components/'
export default {
  components: {
    MyModal
  },
  data () {
    return {
      currentPage: this.$store.state.gcrmod.currentPage,
      paginationButtonsLimit: 3
    }
  },
  created: function () {
    // we hook into the created lifecycle to start grabbing data from firestore
    this.$store.dispatch('gcrmod/showAllClaimReportJobs', { orderBys: 'createdDate' })
  },
  methods: {
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.commit('gcrmod/changePageNumber', this.currentPage)
      this.$store.dispatch('gcrmod/showAllClaimReportJobs', { orderBys: 'createdDate' })
    },
    rowsPerPageSelected: function (rows) {
      console.log('rowsPerPageSelected, rows: ' + rows)
      let intRows = parseInt(rows)
      if (this.$store.state.gcrmod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('gcrmod/changePageNumber', this.currentPage)
        this.$store.commit('gcrmod/setRowsPerPage', intRows)
        this.$store.dispatch('gcrmod/showAllClaimReportJobs', { orderBys: 'createdDate' })
      }
    },
    tableRowClicked: function (item, index, event) {
      console.log('Table row clicked')
      console.log('item: ' + item)
      // console.log('index: ' + index)
      // let taxInvoice = null
      // for (let i in item) {
      //   // console.log('i: ' + i + ', ' + item[i])
      //   if (i === 'taxInvoice') {
      //     taxInvoice = item[i]
      //   }
      // }
      // // console.log('event: ' + event)

      // document.body.classList.add('footer-hidden')
      // this.$store.commit('usrstomod/updatedSelectedTaxInvoice', taxInvoice)
      // this.$store.dispatch('usrstomod/fetchInvoiceDetails', { taxInvoice: taxInvoice })
    },
    refreshTable: function () {
      this.$store.dispatch('gcrmod/showAllClaimReportJobs', { orderBys: 'createdDate' })
    },
    generateClaims: function () {
      this.$store.dispatch('gcrmod/generateClaimsReports')
    },
    downloadFileFromGCS: function (selectedJobNumber) {
      console.log('Download zip file from GCS, jobNumber: ' + selectedJobNumber)
      if (selectedJobNumber) {
        this.$store.dispatch('gcrmod/downloadFileFromGCS', { jobNumber: selectedJobNumber })
      }
    },
    closeGeneratingModal: function () {
      this.$store.commit('gcrmod/toggleShowGeneratingModal', false)
    },
    closeGeneratingSuccessModal: function () {
      this.$store.commit('gcrmod/toggleShowGeneratingSuccessModal', false)
    },
    closeGeneratingFailModal: function () {
      this.$store.commit('gcrmod/toggleShowGeneratingFailedModal', false)
    },
    closeCannotGenerateModal: function () {
      this.$store.commit('gcrmod/toggleShowCannotGenerateModal', false)
    }
  },
  computed: {
    tableRows: function () {
      return this.$store.state.gcrmod.all
    },
    tableHeaders: function () {
      return this.$store.getters['gcrmod/getHeaders']
    },
    totalRowsC: function () {
      return this.$store.state.gcrmod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.gcrmod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('gcrmod/setRowsPerPage', newValue)
      }
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.gcrmod.rowsPerPage
    },
    showLoadingAnimation: function () {
      return this.$store.state.gcrmod.showLoadingAnimation
    },
    showLoadingError: function () {
      return this.$store.state.gcrmod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.gcrmod.showNoResult
    },
    showGeneratingModal: function () {
      return this.$store.state.gcrmod.showGeneratingModal
    },
    showGeneratingSuccessModal: function () {
      return this.$store.state.gcrmod.showGeneratingSuccessModal
    },
    showGeneratingFailedModal: function () {
      return this.$store.state.gcrmod.showGeneratingFailedModal
    },
    showCannotGenerateModal: function () {
      return this.$store.state.gcrmod.showCannotGenerateModal
    }
  },
  name: 'generateclaimreports'
}
</script>



// WEBPACK FOOTER //
// src/views/GenerateClaimReports.vue